<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('saleContract.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('saleContract.pageTitle'),
            href: '/admin/sale-contracts'
          },
          {
            text: $t('update'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row">
            <div class="col-md-9">
              <ProductList v-model="model" @calculate="recalculate" />
              <ItemDetail v-model="model" class="ts-mt-3" ref="itemDetail" />
            </div>
            <div class="col-md-3 ts-space-y-3">
              <RefDate v-model="model" :validate="errors" />
              <Customer v-model="model" :validate="errors" />
              <div v-if="false">
                <b-card no-body>
                  <b-card-header
                    header-tag="header"
                    class="card-header pointer-cursor collapsed"
                    aria-expanded="false"
                    v-b-toggle.addBroker
                  >
                    <i
                      class="fas"
                      :class="isBrokerVisible ? 'fa-minus' : 'fa-plus'"
                    ></i>
                    {{ $t('saleContract.addBroker') }}
                  </b-card-header>
                  <b-collapse
                    id="addBroker"
                    visible
                    accordion="addBroker"
                    v-model="isBrokerVisible"
                  >
                    <b-card-body
                      style="
                        padding: 0 0 0 0;
                        background-color: rgba(99, 179, 237, var(--bg-opacity));
                      "
                    >
                      <div>
                        <Broker v-model="model" :validate="errors" />
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
              <PaymentDate v-model="model" :validate="errors" />
              <ExchangeRate v-model="model" :validate="errors" />
              <DespositPayment
                v-model="model"
                @calculate="recalculate"
                @loading="value => (loading = value)"
                :validate="errors"
              />
              <div v-if="false">
                <b-card no-body>
                  <b-card-header
                    header-tag="header"
                    class="card-header pointer-cursor collapsed"
                    aria-expanded="false"
                    v-b-toggle.advanceOption
                  >
                    <i
                      class="fas"
                      :class="isVisible ? 'fa-minus' : 'fa-plus'"
                    ></i>
                    {{ $t('saleContract.moreFields') }}
                  </b-card-header>
                  <b-collapse
                    id="advanceOption"
                    visible
                    accordion="advanceOption"
                    v-model="isVisible"
                  >
                    <b-card-body
                      style="
                        padding: 0 0 0 0;
                        background-color: rgba(99, 179, 237, var(--bg-opacity));
                      "
                    >
                      <div>
                        <Status v-model="model" :validate="errors" />
                        <Promotion v-model="model" :validate="errors" />
                        <SaleContractType v-model="model" :validate="errors" />
                        <PreviewOption v-model="model" :validate="errors" />
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2">
              <ts-button
                @click.prevent="$router.push({ name: 'sale-contract' })"
                >{{ $t('cancel') }}</ts-button
              >
              <ts-button
                :waiting="waiting_preview"
                @click.prevent="onUpdatePreview"
                color="primary"
                outline
                >{{ $t('updatePreview') }}</ts-button
              >
              <ts-button
                :waiting="waiting"
                @click.prevent="onUpdate"
                color="primary"
                >{{ $t('update') }}</ts-button
              >
            </div>
          </div>
        </ts-loading-banner>
        <a-modal
          :title="$t('pdf')"
          width="50%"
          v-model="show_pdf"
          :footer="null"
        >
          <ts-preview-pdf v-model="waiting_preview" :src="src" />
        </a-modal>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions, mapGetters, mapState } from 'vuex'
import Detail from './components/item-detail'
import RefDate from './components/ref-date.vue'
import Customer from './components/customer.vue'
import PaymentDate from './components/payment-date.vue'
import Status from './components/status.vue'
import ExchangeRate from './components/exchange-rate.vue'
import DespositPayment from './components/desposit-payment.vue'
import ProductList from './components/product-list.vue'
import ItemDetail from './components/item-detail.vue'
import PreviewOption from './components/preview-option.vue'
import Promotion from './components/promotion.vue'
import SaleContractType from './components/sale-contract-type.vue'
import Broker from './components/broker.vue'

export default {
  name: 'saleContractEdit',
  components: {
    Detail,
    RefDate,
    Customer,
    PaymentDate,
    Status,
    ExchangeRate,
    DespositPayment,
    ProductList,
    ItemDetail,
    PreviewOption,
    Promotion,
    SaleContractType,
    Broker
  },
  data() {
    return {
      waiting: false,
      waiting_preview: false,
      loading: false,
      show_pdf: false,
      isVisible: false,
      isBrokerVisible: false,
      errors: new Errors(),
      src: null,
      model: {
        contract_date: moment().format('DD-MM-YYYY'),
        project_name: null,
        customer_id: null,
        grand_total: null,
        vat_rate: null,
        vat_amount: null,
        total_exclude_vat: null,
        reference_no: null,
        credit_day: 0,
        payment_expiry_date: moment()
          .add(15, 'days')
          .format('DD-MM-YYYY'),
        expected_delivery_date: moment()
          .add(7, 'days')
          .format('DD-MM-YYYY'),
        kads: null,
        sc_status_id: 3,
        fx_rate_khr: 0,
        fx_rate_thb: 0,
        deposit_amount: 0,
        payment_method_id: null,
        bank_name: null,
        account_name: null,
        account_number: null,
        exclude_price: false,
        currency: 'USD',
        remark: '',
        item_list: [],
        broker_amount: null,
        promotion_name: null,
        promotion_amount: null,
        sale_type_id: null,
        broker_id: null,
        seller_id: null,
        sub_total: 0,
        discount_rate: 0,
        discount_type: 0,
        discount_amount: 0,
        total_after_discount: 0,
        vat_amount: 0,
        grand_total: 0
      }
    }
  },
  created() {
    this.model.vat_rate = parseFloat(
      this.$store.state.authUser.sys_setting.vat_rate
    )
  },
  computed: {
    ...mapState('wholesale/saleContract', ['customers', 'edit_data']),
    ...mapGetters('wholesale/saleContract', ['getCost']),
    customerList() {
      return this.customers.map(el => ({
        value: el.customer_id,
        label: el.customer_name
      }))
    },
    default_precision() {
      return this.$store.state.authUser.sys_setting.decimal_digit
    }
  },
  methods: {
    ...mapActions('wholesale/saleContract', [
      'getFormViewData',
      'update',
      'find'
    ]),
    async fetchData() {
      this.loading = true
      await this.getFormViewData({
        params: undefined,
        index: undefined
      })
      await this.find(this.$route.params.id)
      this.setEditData()
      this.loading = false
    },
    onUpdatePreview() {
      this.waiting_preview = true
      this.show_pdf = true
      this.errors = new Errors()
      this.update({
        id: this.model.contract_id,
        data: this.model
      })
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.waiting_preview = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.errors = new Errors()
      this.update({
        id: this.model.contract_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'sale-contract' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    recalculate() {
      this.$refs.itemDetail.calculate()
    },
    setEditData() {
      this.model.contract_id = this.edit_data.contract_id
      this.model.contract_date = this.edit_data.contract_date
      this.model.project_name = this.edit_data.project_name
      this.model.customer_id = this.edit_data.customer_id
      this.model.grand_total = this.edit_data.grand_total
      this.model.vat_rate = this.edit_data.vat_rate
      this.model.vat_amount = this.edit_data.vat_amount
      this.model.reference_no = this.edit_data.reference_no
      this.model.total_exclude_vat = this.edit_data.total_exclude_vat
      this.model.credit_day = this.edit_data.credit_day
      this.model.payment_expiry_date = this.edit_data.payment_expiry_date
      this.model.expected_delivery_date = this.edit_data.expected_delivery_date
      this.model.kads = this.edit_data.kads
      this.model.sc_status_id = this.edit_data.sc_status_id
      this.model.fx_rate_khr = this.edit_data.fx_rate_khr
      this.model.fx_rate_thb = this.edit_data.fx_rate_thb
      this.model.deposit_amount = this.edit_data.deposit_amount
      this.model.payment_method_id = this.edit_data.payment_method_id
      this.model.account_name = this.edit_data.account_name
      this.model.account_number = this.edit_data.account_number
      this.model.bank_name = this.edit_data.bank_name
      this.model.remark = this.edit_data.remarks
      this.model.item_list = []
      this.model.broker_amount = this.edit_data.broker_amount
      this.model.promotion_name = this.edit_data.promotion_name
      this.model.promotion_amount = this.edit_data.promotion_amount
      this.model.sale_type_id = this.edit_data.sale_type_id
      this.model.broker_id = this.edit_data.broker_id
      this.model.seller_id = this.edit_data.seller_id
      this.model.sub_total = parseFloat(this.edit_data.sub_total)
      this.model.discount_amount = parseFloat(this.edit_data.discount || 0)
      this.model.total_after_discount = parseFloat(
        this.edit_data.total_after_discount || 0
      )
      this.model.grand_total = parseFloat(this.edit_data.grand_total)
      this.edit_data.details.forEach(el => {
        this.$store.commit('wholesale/saleContract/PUSH_NEW_QUOTATION', [
          this.edit_data.reference_no
        ])
        this.$store.commit('wholesale/saleContract/SET_PRODUCT', {
          uom_cat_id: el.product.uom_cat_id,
          product_id: el.product_id,
          sale_code: el.sale_code,
          uom_category: el.product.uom_category
        })

        let unitPriceAfterDiscount = el.unit_price

        if (el.discount_type === '%') {
          unitPriceAfterDiscount =
            el.unit_price -
            (el.unit_price * parseFloat(el.discount_rate || 0)) / 100
        } else {
          unitPriceAfterDiscount =
            el.unit_price - parseFloat(el.discount_rate || 0)
        }

        this.model.item_list.push({
          product_id: el.product_id,
          uom_id: el.uom_id,
          quantity: el.quantity,
          unit_price: el.unit_price,
          remarks: el.remarks,
          amount: _.round(el.quantity * unitPriceAfterDiscount, 4),
          amount_in_bath: el.amount_in_bath,
          storage_location: el.storage_location,
          product_name_en: el.product_name_en,
          barcode: el.barcode,
          balance: 'no refresh',
          sale_code: el.sale_code[0],
          cost: this.getCost({
            product_id: el.product_id,
            uom_id: el.uom_id
          }),
          discount_type: el.discount_type,
          discount_rate: parseFloat(el.discount_rate),
          discount_amount: parseFloat(el.discount_amount),
          total_after_discount: el.total_after_discount,
          vat_rate: el.vat_rate,
          vat_amount: el.vat_amount,
          grand_total: parseFloat(el.grand_total).toFixed(
            this.default_precision
          )
        })
      })
      this.$nextTick(() => {
        this.$forceUpdate()
        this.$refs.itemDetail.getProductBalance()
        this.getFormViewData({
          index: 'customer',
          params: {
            fnName: 'customer',
            customer_id: this.edit_data.customer_id
          }
        })
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/saleContract/CLEAR_SETUP')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
<style scoped>
.card-header {
  background-color: #edf2f7;
}
</style>
